import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private httpClient: HttpClient
  ) {}

  getDoc(url: string): Observable<any> {
    return this.httpClient.get(`assets/json/${url}.json`)
  }

  get(url: string, headers?: Record<string, string>): Observable<any> {
    return this.httpClient.get(`${environment.apiBaseUrl}${url}`, { headers })
  }

  post(url: string, data: any, headers?: Record<string, string>): Observable<any> {
    return this.httpClient.post(`${environment.apiBaseUrl}${url}`, data, { headers })
  }

  put(url: string, data: any): Observable<any> {
    return this.httpClient.put(`${environment.apiBaseUrl}${url}`, data)
  }

  delete(url: string, options?: any): Observable<any> {
    return this.httpClient.delete(`${environment.apiBaseUrl}${url}`, options)
  }
}
